import { __exports as n } from "./index790.mjs";
import { a as s } from "./index777.mjs";
var o = s, l = TypeError, f = function(r) {
  var e, a;
  this.promise = new r(function(i, t) {
    if (e !== void 0 || a !== void 0)
      throw new l("Bad Promise constructor");
    e = i, a = t;
  }), this.resolve = o(e), this.reject = o(a);
};
n.f = function(r) {
  return new f(r);
};
export {
  n as default
};
